"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Consultation() {
  const headline = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const copy = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const actions = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const actionBlocks = [{
    title: "Book a session",
    to: "/HotelRevenueManagementConsultingPage",
    meta: "For clients"
  }, {
    title: "Corporate inquiries",
    to: "/ContactPage",
    meta: "For businesses"
  }];
  return <section data-section-id="19632" id="consultation-cta" className="bg-background text-foreground border-t border-border">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16 py-32 md:py-44">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-6 gap-y-16">
          {}
          <div className="md:col-span-8 flex flex-col">
            <div ref={headline.ref} className={"transition-all duration-[480ms] ease-out " + (headline.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3")}>
              <h2 className="font-default text-foreground" style={{
              fontSize: "clamp(2rem, 5.2vw, 4.75rem)",
              fontWeight: 600,
              letterSpacing: "-0.022em",
              lineHeight: 1.02
            }}>
                Start your{" "}
                <span style={{
                fontWeight: 300
              }}>journey</span>
              </h2>
            </div>

            <p ref={copy.ref} className={"mt-12 max-w-[52ch] text-muted-foreground transition-all duration-[480ms] ease-out delay-[60ms] " + (copy.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3")} style={{
            fontSize: "clamp(1.0625rem, 1.1vw, 1.1875rem)",
            fontWeight: 400,
            letterSpacing: "-0.003em",
            lineHeight: 1.55
          }}>
              For clients: schedule a personalized consultation to discuss your goals. For businesses: reach out to explore professional partnerships and tailored solutions designed for your growth.
            </p>
          </div>

          {}
          <div ref={actions.ref} className={"md:col-span-4 flex flex-col transition-all duration-[480ms] ease-out delay-[140ms] " + (actions.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3")}>
            {actionBlocks.map((block, i) => <Link key={i} data-index={i} to={block.to} className={"group flex items-center justify-between px-6 md:px-8 h-[88px] md:h-24 transition-colors duration-[180ms] ease-out hover:bg-accent " + (i === 0 ? "border-y border-border" : "border-b border-border")}>
                <div className="flex flex-col">
                  <span className="text-muted-foreground uppercase" style={{
                fontSize: "0.75rem",
                fontWeight: 500,
                letterSpacing: "0.08em",
                lineHeight: 1.4
              }}>
                    {block.meta}
                  </span>
                  <span className="font-default text-foreground mt-2" style={{
                fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
                fontWeight: 500,
                letterSpacing: "-0.006em",
                lineHeight: 1.25
              }}>
                    {block.title}
                  </span>
                </div>
                <ArrowRight className="text-foreground transition-transform duration-[220ms] ease-out group-hover:translate-x-1" size={24} strokeWidth={1.5} />
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}